import React, { PureComponent, useCallback, useState } from 'react';
import styled from 'styled-components';
import { EnumSection, IAvailableCompetition, IScarfInfo } from '../../interfaces/clientInterfaces';
import { Link } from 'react-router-dom';
import ShieldsRenderer from './ShieldsRenderer';
import { StyledAnimatedOnHover } from './SideTree';
import { ALL_COUNTRIES_NAME, SHOW_MAP_STADIUM_KEY } from '../constants';
import { Competitions } from '../../utils/competitions';
import { Localizer } from '../../utils/localizer';
import { Countries } from '../../utils/countries';
import ReserveTeamInfo from './ReserveTeamInfo';
import { useSelector } from 'react-redux';
import { INumberDictionary, IStore } from '../../interfaces';
import * as actions from '../../actions';
import { useAppDispatch } from '../../utils/modules';
import styles from './TeamInfoRenderer.module.css';

//#region styled Components


interface ITeamFlexContainer {
	isReducedView: boolean;
}
const TeamFlexContainer = styled.div<ITeamFlexContainer>`
	background-color: transparent;
	flex: 1;
	display: flex;
	flex-direction: ${props => props.isReducedView ? 'row' : 'column'};
	${props => props.isReducedView ? 'max-width: 300px; margin: auto;' : ''}
`;

interface ITeamShieldsContainer {
	isReducedView: boolean;
	isMobileViewActive: boolean;
}
const TeamShieldsContainer = styled.div<ITeamShieldsContainer>`
	flex: 1;
	display: flex;
	margin-top: ${props => props.isReducedView ? '0' : props.isMobileViewActive ? '10px' : '15px'};

`;

interface IScarfContainer {
	isMapInfo?: boolean;
	isHomeSection?: boolean;
	isMobileViewActive: boolean;
}
const ScarfContainer = styled.div<IScarfContainer>`
	display: flex; 
	flex-direction: column;
	margin-top: ${props => props.isMapInfo || props.isMobileViewActive ? '0px' : '15px'};
	max-height: ${props => props.isMapInfo ? '150px' : props.isHomeSection ? '100px' : 'auto'};
	overflow: ${props => props.isMapInfo || props.isHomeSection ? 'auto' : 'hidden'};
`;

interface INameContainer {
	color: string;
	backgroundColor: string; 
	borderColor: string;
	isMobileViewActive: boolean;
}
const NameContainer = styled.div<INameContainer>`
	color: ${props => props.color};
	background-color: ${props => props.backgroundColor};
	border: ${props => `3px solid ${props.borderColor}`};
	height: ${props => props.isMobileViewActive ? '25px' : '30px'};
	line-height: ${props => props.isMobileViewActive ? '25px' : '30px'};
	width: 220px;
	text-align: center;
	font-weight: 700;
	user-select: none;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	padding: 0 5px 0 5px;
	border-radius: 4px;
`;

const ContainerNameZone = styled.div`
	display: flex;
	margin: auto;
	width: 250px;
`;

interface IInfoFlexContainer {
	isMobileViewActive: boolean;
}
const InfoFlexContainer = styled.div<IInfoFlexContainer>`
	display: flex;
	margin: auto;
	font-size: ${props => props.isMobileViewActive ? '11px' : '12px'};
`;

const TrohpiesInfoFlexContainer = styled.div`
	margin: auto 7px auto 7px;
	display: flex;
	font-size: 12px;
	flex-direction: column;
`;

interface IInfoFlexContainer {
	textAlign?: string;
}
const InfoContainerColumn = styled.div<IInfoFlexContainer>`
	flex: 1;
	text-align: ${props => props.textAlign || 'left'};
	padding: 7px;
	text-shadow: 2px 2px 2px black;
`;

const InfoContainerColumnRow = styled.div`
	flex: 1;
`;

const StadiumInfoContainerColumnRow = styled(InfoContainerColumnRow)`
	display: inline-block;
`;

interface IImage {
	isRunnerUp?: boolean;
	isMobileViewActive: boolean;
}
const Image = styled.img<IImage>`
	max-height: ${props => props.isMobileViewActive ? '55px' : '70px'};
	filter: ${props => props.isRunnerUp ? 'opacity(0.7)' : 'drop-shadow(2px 8px 7px gold)'};
`;

interface ITrophiesContainer {
	isHomeSection?: boolean;
	isMobileViewActive?: boolean;
}
const TrophiesContainer = styled.div<ITrophiesContainer>`
	display: flex;
	margin: auto;
	width: 100%;
	flex-flow: ${props => props.isHomeSection ? 'row' : 'row wrap'};
	justify-content: ${props => props.isHomeSection ? 'space-between' : 'center'};
	overflow-x: ${props => props.isHomeSection ? 'auto' : 'hidden'};
	max-width: ${props => props.isMobileViewActive ? '100%' : '90%'}
`;

const TrophyContainer = styled.div`
	margin-right: 16px;
`;

interface ICircleContainer {
	isRunnerUp: boolean;
}
const CircleContainer = styled.div<ICircleContainer>`
	align-items: center;
	display: flex;
	height: 23px;
	justify-content: center;
	max-width: 100%;
	overflow: auto;
	position: relative;
	top: -8px;
	left: 8px;
	svg {
		height: 100%;
	}
	circle {
		fill: ${props => props.isRunnerUp ? '#6c7a86' : '#DAA520'};
	}
	text { 
		fill: ${props => props.isRunnerUp ? '#fff' : '#222'};
		font-size: 4rem;
		font-family: Europa-Big;
	}
`;
interface IImageRenderer {
	isMapInfo?: boolean;
	isHomeSection?: boolean;
	isMobileViewActive?: boolean;
}
const ImageRenderer = styled.img<IImageRenderer>`
	width: ${props => props.isHomeSection ? '90%' : props.isMobileViewActive ? '90vw' : props.isMapInfo ? '400px' : '575px;'};
	max-width: 575px;
	margin: auto auto 10px auto;
`;

const MapIconContainer = styled(StyledAnimatedOnHover)`
	display: inline-block;
	margin-left: 5px;
	:hover {
		color: black;
		i {
			color: #F89504;
		}
	}
	a {
		color: transparent;
	}
	i {
		font-size: 12px;
		line-height: 12px;
		cursor: pointer;
		color: white;
		text-shadow: 2px 2px 2px black;
	}
`;

const ImageLinkContainer = styled.img`
	max-height: 11px;
	margin: auto 0 auto 5px;
	display: flex;
`;

const ContainerNameAndFlag = styled.div`
	display: flex;
`;

const DetailSymbolContainer = styled.div`
	display: flex;
`;

const DetailSymbol = styled.div`
	height: 15px;
  	width: 15px;
  	background-color: #F89504;
  	border-radius: 50%;
	display: flex;
	cursor: pointer;
	margin: auto 5px auto 0;
	position: relative;
	i {
		font-size: black;
		color: black;
		margin: auto;
		font-size: 10px;
	}
`;

const ScarfCommentContainer = styled.div<IImageRenderer>`
	font-size: 12px;
	margin: auto;
	background-color: rgba(255, 255, 255, 0.6);
	color: black;
	padding: 5px 3px;
	border-radius: 4px;
	width: ${props => props.isHomeSection ? '90%' : props.isMobileViewActive ? '90vw' : props.isMapInfo ? '400px' : '575px;'};

`;

//#endregion
class TitleCircle extends PureComponent<{ number: number, isRunnerUp: boolean }, { }> {
	public render() {
		return (
			<CircleContainer isRunnerUp={this.props.isRunnerUp}>
				<svg viewBox='0 0 140 140' preserveAspectRatio='xMinYMin meet'>
					<g>
						<circle r='50%' cx='50%' cy='50%' className='circle-back' />
						<text x='50%' y='50%' textAnchor='middle' dy='0.3em'>
							{this.props.number}	
						</text>
					</g>
				</svg> 
			</CircleContainer>
		);
	}
}

interface ITeamInfoRendererProps {
	scarfInfo: IScarfInfo;
	isMapInfo: boolean;
	section: EnumSection;
}

export default function TeamInfoRenderer({
	scarfInfo,
	isMapInfo,
	section,
}: ITeamInfoRendererProps) {

	const dispatch = useAppDispatch();
	
	const [clickIndex, setClickIndex] = useState(0);

	const isMobileViewActive = useSelector(
		(completeState: IStore): boolean => { 
			return completeState?.ui?.isMobileViewActive ?? false;
		});

	const areTeamHonoursVisible = useSelector(
		(completeState: IStore): boolean => { 
			return completeState?.ui?.areTeamHonoursVisible ?? false;
		});
	
	const isReducedView = useSelector(
		(completeState: IStore): boolean => { 
			return completeState?.ui?.isReducedView ?? false;
		});

	const currentCountry = useSelector(
		(completeState: IStore): string | undefined => { 
			return completeState?.ui?.currentCountry ?? undefined;
		});

	const competitionsWithEvolution = useSelector(
		(completeState: IStore): INumberDictionary<IAvailableCompetition> => { 
			return completeState?.competitions.competitionsWithEvolution ?? {}
		});

	const shieldClick = useCallback(
		() => {
			let modifiedClickIndex = clickIndex;
			if (clickIndex % 2 === 0) {
				modifiedClickIndex++;
				setClickIndex(modifiedClickIndex);
			}
		},
		[clickIndex]
	);

	const titleClick = useCallback(
		() => {
			let modifiedClickIndex = clickIndex;
			if (modifiedClickIndex % 2 !== 0) {
				modifiedClickIndex++;
				if (clickIndex > 3) {
					setClickIndex(modifiedClickIndex);
					if (section === EnumSection.gallery) {
						dispatch(actions.setHonoursVisibility());
					}
				} else {
					setClickIndex(modifiedClickIndex);
				}
			}
		},
		[clickIndex, dispatch, section]
	);

	const trophyClick = useCallback(
		(
			e: React.MouseEvent<HTMLDivElement>,
			title: string,
			editions: string,
			description: string | undefined,
			competitionId: number
		) => {
			e.persist();
			dispatch(actions.setTrophyTooltip({
				x: e.clientX,
				y: e.clientY,
				title,
				editions,
				description,
				id: competitionId,
				hasDetail: !!competitionsWithEvolution[competitionId],
				competitionName: competitionsWithEvolution[competitionId]?.name ?? ''
			}));
		},
		[competitionsWithEvolution, dispatch]
	);

	const renderName = useCallback(
		() => {
			return (
				<ContainerNameZone>
					<NameContainer
						color={`#${scarfInfo.team.secondColor}`}
						backgroundColor={`#${scarfInfo.team.firstColor}`}
						borderColor={`#${scarfInfo.team.thirdColor}`}
						title={scarfInfo.team.name}
						onClick={titleClick}
						isMobileViewActive={isMobileViewActive}
					>
						{scarfInfo.team.name.replace('*', '')}
					</NameContainer>
					{scarfInfo.team.name.indexOf('*') > -1 && <ReserveTeamInfo
						countryCode={scarfInfo.team.countryCode}
						firstColor={scarfInfo.team.firstColor}
						secondColor={scarfInfo.team.secondColor}
					/>}
				</ContainerNameZone>
			);
		},
		[isMobileViewActive, scarfInfo.team.countryCode, scarfInfo.team.firstColor, scarfInfo.team.name, scarfInfo.team.secondColor, scarfInfo.team.thirdColor, titleClick]
	);

	const titleDetail = useCallback(
		() => {
			dispatch(actions.onSetTitleDetail(scarfInfo.team));
		},
		[scarfInfo, dispatch]
	);

	const renderCityAndFlag = useCallback(
		() => {
			const countryName = Localizer.getLocalizedCountryName(scarfInfo.team.countryCode);
			return (
				<ContainerNameAndFlag>
					<InfoContainerColumnRow>{`Town: ${scarfInfo.city.name}, ${scarfInfo.city.region}`}</InfoContainerColumnRow>
					{
						section === EnumSection.gallery && currentCountry && Countries.isCountrySelectableByRegion(currentCountry)
							? <ImageLinkContainer src={`../../../img/flag/${scarfInfo.city.region}.png`} alt={scarfInfo.city.region} title={scarfInfo.city.region} />
							: null
					}
					{
						section === EnumSection.gallery && (
							currentCountry === ALL_COUNTRIES_NAME ||
							currentCountry === 'EU' ||
							currentCountry === 'SA' ||
							currentCountry === 'NA' ||
							currentCountry === 'AF' ||
							currentCountry === 'AS' ||
							currentCountry === 'OC' ||
							currentCountry === 'YU' ||
							currentCountry === 'UR' ||
							currentCountry === 'UK' ||
							currentCountry === 'ZK'
						)
							? <ImageLinkContainer src={`../../../img/flag/${scarfInfo.team.countryCode}.png`} alt={countryName} title={countryName} />
							: null
					}
				</ContainerNameAndFlag>
			);
		},
		[currentCountry, scarfInfo.city.name, scarfInfo.city.region, scarfInfo.team.countryCode, section]
	);

	const seasonsTop = Competitions.getSeasonsInTopCategoryString(scarfInfo.team);

	return (
		<div 
			className={isMapInfo
				? styles.groupContainerMap
				: section === EnumSection.home
					? styles.groupContainerHome
					: isReducedView
						? styles.groupContainerReduced
						: isMobileViewActive
							? styles.groupContainerMobile
							: styles.groupContainer
			}
		>
			{!isReducedView && renderName()}
			<TeamFlexContainer
				isReducedView={isReducedView ? true : false}
				onClick={shieldClick}
			>
				<TeamShieldsContainer
					isReducedView={isReducedView ? true : false}
					isMobileViewActive={isMobileViewActive}
				>
					<ShieldsRenderer
						teamId={scarfInfo.team.teamId}
					/>
				</TeamShieldsContainer>
				{isReducedView && renderName()}
			</TeamFlexContainer>
			{!isReducedView &&
				<>
					<InfoFlexContainer
						isMobileViewActive={isMobileViewActive}
					>
						<InfoContainerColumn
							isMobileViewActive={isMobileViewActive}
							textAlign={'right'}
						>
							{scarfInfo.city.name && renderCityAndFlag()}
							{scarfInfo.team.founded ? <InfoContainerColumnRow>{`Founded: ${scarfInfo.team.founded}`}</InfoContainerColumnRow> : null}
							{scarfInfo.team.dissolved ? <InfoContainerColumnRow>{`Dissolved: ${scarfInfo.team.dissolved}`}</InfoContainerColumnRow> : null}
							{scarfInfo.team.categoryString ? <InfoContainerColumnRow>{`Category: ${scarfInfo.team.categoryString}`}</InfoContainerColumnRow> : null}
							{areTeamHonoursVisible && scarfInfo.team.overallRanking ? <InfoContainerColumnRow>{`Ranking: ${scarfInfo.team.overallRanking}`}</InfoContainerColumnRow> : null}
							{areTeamHonoursVisible && scarfInfo.team.noTitleRanking ? <InfoContainerColumnRow>{`No Title Ranking: ${scarfInfo.team.noTitleRanking}`}</InfoContainerColumnRow> : null}
							{areTeamHonoursVisible && scarfInfo.team.honours.numberOfTitles ? <InfoContainerColumnRow>{`Number of titles: ${scarfInfo.team.honours.numberOfTitles}`}</InfoContainerColumnRow> : null}
							{areTeamHonoursVisible ? <InfoContainerColumnRow>{`Id: ${scarfInfo.team.teamId}`}</InfoContainerColumnRow>: null}
						</InfoContainerColumn>
						<InfoContainerColumn
							isMobileViewActive={isMobileViewActive}
						>
							{scarfInfo.stadium.name && 
								<StadiumInfoContainerColumnRow>
									{`Stadium: ${scarfInfo.stadium.name}`}
									{!isMapInfo && section !== EnumSection.home &&
										<MapIconContainer>
											<Link to={`/map?center=${scarfInfo.team.name}`}>
												<i className='fa fa-map-marker' title={SHOW_MAP_STADIUM_KEY}/>
											</Link>
										</MapIconContainer>
									}
								</StadiumInfoContainerColumnRow>
							}
							{scarfInfo.stadium.capacity ? <InfoContainerColumnRow>{`Capacity: ${scarfInfo.stadium.capacity}`}</InfoContainerColumnRow> : null}
							{areTeamHonoursVisible ? <InfoContainerColumnRow>{`Seasons Top Percentage: ${scarfInfo.team.seasonsTopPercentage}`}</InfoContainerColumnRow>: null}
							{seasonsTop ? <InfoContainerColumnRow>{`Seasons in top division: ${seasonsTop}`}</InfoContainerColumnRow> : null}
							{scarfInfo.team.seasonsTop < scarfInfo.team.seasons2nDiv ? <InfoContainerColumnRow>{`Seasons in second division: ${scarfInfo.team.seasons2nDiv}`}</InfoContainerColumnRow> : null}
						</InfoContainerColumn>
					</InfoFlexContainer>
					<TrohpiesInfoFlexContainer>
						<TrophiesContainer
							isHomeSection={section === EnumSection.home && (scarfInfo.team.honours.completeChampion.length + scarfInfo.team.honours.runnerUp.length > 4)}
							isMobileViewActive={isMobileViewActive}
						>
							{
								(scarfInfo.team.honours.completeChampion.length > 0 || scarfInfo.team.honours.runnerUp.length > 0) &&
									<DetailSymbolContainer
										title={'See detailed titles'}
										onClick={titleDetail}
									>
										<DetailSymbol>
											<i className='fa fa-plus'/>
										</DetailSymbol>
									</DetailSymbolContainer>
							}
							{
								scarfInfo.team.honours.champion.map((x, i) => {
									const title = `${x.name} Champion: `;
									const editions = x.editions.map(e => e.text).join(', ');
									return (
										<TrophyContainer key={`championTrophy-${i}`} onClick={e => trophyClick(e, title, editions, x.description, x.competitionId)}>
											<Image
												src={`./../../img/trophy/${x.competitionCode}${x.lastTrophy ? `_${x.lastTrophy}`: ''}.png`}
												title={title}
												isMobileViewActive={isMobileViewActive}
											/>
											<TitleCircle number={x.editions.length} isRunnerUp={false} />
										</TrophyContainer>
									);
								})
							}
							{
								scarfInfo.team.honours.runnerUp.map((x, i) => {
									const title = `${x.name} Runner Up: `;
									const editions = x.editions.map(e => e.text).join(', ');
									return (
										<TrophyContainer key={`runnerUpTrophy-${i}`} onClick={e => trophyClick(e, title, editions, x.description, x.competitionId)}>
											<Image
												src={`./../../img/trophy/${x.competitionCode}${x.lastTrophy ? `_${x.lastTrophy}`: ''}.png`}
												title={title}
												isRunnerUp={true}
												isMobileViewActive={isMobileViewActive}
											/>
											<TitleCircle number={x.editions.length} isRunnerUp={true} />
										</TrophyContainer>
									);
								})
							}
						</TrophiesContainer>
					</TrohpiesInfoFlexContainer>
				</>
			}
			<ScarfContainer
				isMapInfo={isMapInfo}
				isHomeSection={section === EnumSection.home}
				isMobileViewActive={isMobileViewActive}
			>
				{
					scarfInfo.scarves.map((x, i) => {
						return (
							<>
								<ImageRenderer
									key={`${scarfInfo.team.name} scarf - ${i}`}
									alt={`${scarfInfo.team.name} scarf`}
									src={`../../../img/scarf/${x.scarfCode}.jpg`}
									title={`${scarfInfo.team.name} scarf`}
									isMapInfo={isMapInfo}
									isHomeSection={section === EnumSection.home}
									isMobileViewActive={isMobileViewActive}
								/>
								{x.comment && <ScarfCommentContainer
									isMapInfo={isMapInfo}
									isHomeSection={section === EnumSection.home}
									isMobileViewActive={isMobileViewActive}
								>{x.comment}</ScarfCommentContainer>}
							</>
						);
					})
				}
			</ScarfContainer>
		</div>
	);
}
